/**
 * Projetos.
 *
 * A tela de CONFIGURACAO do projeto (fluxo, tipos, etiquetas, membros,
 * GitLab) nao entra no menu de proposito: chega-se a ela pelo projeto, e um
 * item de menu chamado "Configuracao do projeto" so faria sentido se houvesse
 * um projeto ativo implicito -- que e justamente a ambiguidade que o redirect
 * do quadro existe para evitar.
 */
export const nav = {
    permissao: 'deck.projetos:ver',
    section: 'Projetos',
    title: 'Projetos',
    icon: 'folder_open',
    route: '/projetos',
    sequence: 10,
};

export default [
    {
        path: '/projetos',
        name: 'projetos',
        component: () => import('./pages/ProjetosPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.projetos:ver' },
    },
    {
        path: '/projetos/novo',
        name: 'projeto-novo',
        component: () => import('./pages/ProjetoFormPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.projetos:criar' },
    },
    {
        path: '/projetos/:projectKey/configuracao',
        name: 'projeto-configuracao',
        component: () => import('./pages/ConfiguracaoDoProjetoPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'deck.projetos:configurar' },
    },
];
